import { c as _c } from "react/compiler-runtime";
import _ from 'lodash';
import type React from 'react';
import { NumericFormat } from 'react-number-format';
import { twMerge } from 'tailwind-merge';
type Props = {
  label?: string | React.ReactNode;
  inline?: boolean;
  prepend?: string | React.ReactNode;
  addon?: string | React.ReactNode;
  name?: string;
  value?: string | number | undefined;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
  optional?: boolean;
} & React.ComponentPropsWithoutRef<'input'>;
export function NumberFormatInput(props) {
  const $ = _c(36);
  const {
    label,
    inline,
    prepend,
    addon,
    id,
    name,
    value,
    placeholder,
    maxLength,
    disabled,
    optional,
    onChange,
    onBlur,
    onFocus
  } = props;
  let t0;
  if ($[0] !== props) {
    t0 = _.get(props, "data-error");
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const errMsg = t0;
  const inputId = id || name;
  const errorId = `${inputId}-error`;
  let t1;
  if ($[2] !== inputId || $[3] !== label || $[4] !== optional) {
    t1 = label && <label htmlFor={inputId} className={twMerge("form-label")}>{label}{optional && <span className="ml-1.5 font-light text-zinc-600 dark:text-zinc-400">(optional)</span>}</label>;
    $[2] = inputId;
    $[3] = label;
    $[4] = optional;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = inline ? "mt-0" : "mt-1";
  let t3;
  if ($[6] !== t2) {
    t3 = twMerge("form-container", t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== prepend) {
    t4 = prepend && <div className="form-prepend" aria-hidden="true">{prepend}</div>;
    $[8] = prepend;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = placeholder || "";
  const t6 = maxLength || undefined;
  const t7 = !!errMsg;
  const t8 = errMsg ? errorId : undefined;
  let t9;
  if ($[10] !== disabled || $[11] !== inputId || $[12] !== name || $[13] !== onBlur || $[14] !== onChange || $[15] !== onFocus || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== value) {
    t9 = <NumericFormat thousandSeparator="," autoComplete="off" id={inputId} name={name} value={value} placeholder={t5} maxLength={t6} disabled={disabled} className="form-input" onChange={onChange} onBlur={onBlur} onFocus={onFocus} aria-invalid={t7} aria-describedby={t8} />;
    $[10] = disabled;
    $[11] = inputId;
    $[12] = name;
    $[13] = onBlur;
    $[14] = onChange;
    $[15] = onFocus;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = value;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== addon) {
    t10 = addon && <div className="form-addon" aria-hidden="true">{addon}</div>;
    $[22] = addon;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t3 || $[26] !== t4 || $[27] !== t9) {
    t11 = <div className={t3}>{t4}{t9}{t10}</div>;
    $[24] = t10;
    $[25] = t3;
    $[26] = t4;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== errMsg || $[30] !== errorId) {
    t12 = errMsg && <div id={errorId} className="form-error-message" aria-live="polite">{errMsg}</div>;
    $[29] = errMsg;
    $[30] = errorId;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t1 || $[33] !== t11 || $[34] !== t12) {
    t13 = <div>{t1}{t11}{t12}</div>;
    $[32] = t1;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}